<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="!!editing">{{ $t('components.EditModelData.title') }} - {{ editing.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.stop="saveDialog = true">{{ $t('components.EditModelData.save') }}</v-btn>
        <v-dialog v-model="saveDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">{{ $t('components.EditModelData.warning') }}</v-card-title>
            <v-card-text>
              {{ $t('components.EditModelData.cannotBeUndone') }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" text @click="saveDialog = false">{{ $t('components.EditModelData.abort') }}</v-btn>
              <v-btn color="red darken-1" text @click="triggerSave">{{ $t('components.EditModelData.confirm') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar-items>
    </v-toolbar>
    <v-container fluid class="my-5" style="width: 98%;">
      <v-layout row justify-center child-flex>
        <external-series-table key="mediaExternalTable" v-model="changesMedia" @input="changesMadeMedia($event)" :series="seriesMedia" :dates="dates" :start="0" :length="dates.length" :title="$t('components.EditModelData.mediaChannels')" :series-header="`${$t('components.EditModelData.mediaChannels')}(${spendUnitName})`" :show-min-max="false" :show-units="false" :global-unit="spendUnitName" :show-chart="false" model-frequency="month" :pretty-names="editing.pretty_names ? editing.pretty_names.media : {}"></external-series-table>
        <external-series-table key="KPIsExternalTable" v-model="changesKPIs" @input="changesMadeKPIs($event)" :series="seriesKPIs" :dates="dates" :start="0" :length="dates.length" :title="$t('components.EditModelData.kpis')" :series-header="globalKPIsUnit ? `${$t('components.EditModelData.kpis')} (${spendUnitName})` : $t('components.EditModelData.kpis')" :show-min-max="false" :show-units="!globalKPIsUnit" :global-unit="spendUnitName" :show-chart="false" model-frequency="month"></external-series-table>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import ExternalSeriesTable from '@/components/ExternalSeriesTable.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ExternalSeriesTable
  },
  data () {
    return {
      changesMedia: {},
      changesKPIs: {},
      saveDialog: false
    }
  },
  methods: {
    ...mapActions('manager', [
      'updateModelData'
    ]),
    closeDialog () {
      this.$emit('close-dialog')
    },
    triggerSave () {
      this.updateModelData({
        client: this.editing.id,
        modelData: this.formattedModelData
      })
      this.saveDialog = false
      this.closeDialog()
    },
    changesMadeMedia: function (data) {
      console.log('Media Changed')
    },
    changesMadeKPIs: function (data) {
      console.log('KPIs Changed')
    }
  },
  computed: {
    formattedModelData () {
      let modelData = []
      for (let index = 0; index < this.dates.length; index++) {
        modelData.push({})
        Object.keys(this.changesMedia).forEach(medium => {
          modelData[index][medium] = this.changesMedia[medium][index]
        })
        Object.keys(this.changesKPIs).forEach(kpi => {
          modelData[index][kpi] = this.changesKPIs[kpi][index]
        })
        modelData[index].name = this.dates[index]
      }
      return modelData
    },
    spendUnitName: function () {
      if ('invest_unit_name' in this.editing.reference_model.config) {
        return this.editing.reference_model.config.invest_unit_name
      } else {
        return 'USD'
      }
    },
    dates () {
      if (this.editing) {
        const dates = this.editing.reference_model.config.dates.all
        const lastDataDate = new Date(this.editing.reference_model.config.dates.last_data)
        const endDate = new Date(this.editing.reference_model.config.dates.end)

        let pastDates = []

        for (const dateIndex in dates) {
          const date = new Date(dates[dateIndex])
          if (date > lastDataDate && date <= endDate) {
            pastDates.push(dates[dateIndex])
          }
        }
        return pastDates
      } else {
        return []
      }
    },
    seriesMedia () {
      if (this.editing) {
        const columns = [...new Set([...Object.keys(this.editing.reference_model.config.media).sort()])]
        return columns.map(col => {
          return [col, { default_values: new Array(this.dates.length).fill(''), min: 0, max: 9999999999 }]
        })
      } else {
        return []
      }
    },
    seriesKPIs () {
      if (this.editing) {
        let kpis = [this.$t('components.EditModelData.defaultKpiName')]
        if ('outputs' in this.editing.reference_model.config) {
          kpis = Object.keys(this.editing.reference_model.config.outputs).sort()
        }
        const columns = [...new Set([...kpis])]
        return columns.map(col => {
          return [col, { default_values: new Array(this.dates.length).fill(''), min: 0, max: 9999999999, unit: this.editing.reference_model.config.outputs && col in this.editing.reference_model.config.outputs ? this.editing.reference_model.config.outputs[col].sales_unit_name : '' }]
        })
      } else {
        return []
      }
    },
    globalKPIsUnit () {
      const firstUnit = this.seriesKPIs[0][1].unit
      return this.seriesKPIs.every(pair => pair[1].unit === firstUnit)
    },
    modelData () {
      let data = []
      if ('model_data' in this.editing) {
        data = this.editing.model_data
      }
      return data
    }
  },
  watch: {
    modelData: {
      immediate: true,
      handler: function (after) {
        if (after) {
          let changesMedia = {}
          for (let index = 0; index < after.length; index++) {
            const element = after[index]
            this.seriesMedia.map(item => item[0]).forEach(item => {
              if (!changesMedia[item]) {
                changesMedia[item] = []
              }
              changesMedia[item][index] = element[item] ? element[item] : ''
            })
          }
          this.changesMedia = { ...changesMedia }
          let changesKPIs = {}
          for (let index = 0; index < after.length; index++) {
            const element = after[index]
            this.seriesKPIs.map(item => item[0]).forEach(item => {
              if (!changesKPIs[item]) {
                changesKPIs[item] = []
              }
              changesKPIs[item][index] = element[item] ? element[item] : ''
            })
          }
          this.changesKPIs = { ...changesKPIs }
        }
      }
    }
  },
  directives: {
  },
  props: {
    editing: {
      type: Object,
      required: false
    }
  }
}
</script>
